export default "__VITE_ASSET__D4eGVY6F__"